@use "Styles/mixins";

:host {
    display: block;
    width: 100%;
}

.list {
    display: flex;
    flex-direction: column;
    width: 100%;
}

:host([variant="card"]) .list {
    gap: 12px;
}

:host([variant="minimal"]) .list {
    gap: 0;
}

.btn {
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-family: inherit;
}

:host([variant="card"]) .btn {
    background-color: mixins.get-color(bg, solid, primary);
    border: 1px solid mixins.get-color(border, border-primary);
    color: mixins.get-color(text, text-secondary);
    padding: 14px 20px;
    font-size: 14px;
    line-height: 1.625;
    border-radius: 12px;
    transition:
        color 150ms,
        background-color 150ms,
        border-color 150ms;

    &:hover {
        border-color: mixins.get-color(background, bg-brand-teal);
        background-color: mixins.get-color(teal, 50);
    }
}

:host([variant="minimal"]) .btn {
    display: flex;
    align-items: center;
    gap: 12px;
    color: mixins.get-color(text, text-secondary);
    padding: 10px 16px;
    font-size: 14px;
    line-height: 1.5;
    border-radius: 8px;
    transition:
        color 150ms,
        background-color 150ms;

    @media (hover: hover) {
        &:hover {
            color: mixins.get-color(text, text-primary);
            background-color: mixins.get-color(background, bg-brand-secondary);
        }
    }

    &:active {
        color: mixins.get-color(text, text-primary);
        background-color: mixins.get-color(background, bg-brand-secondary);
    }
}

.icon {
    flex-shrink: 0;
    color: #a4a7ae; // gray-400 — not exposed in $colors with a fitting semantic key
}

.skeleton {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;

    min-height: 21px;

    &__icon {
        @include mixins.skeleton-block;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
    }

    &__text {
        @include mixins.skeleton-block;
        height: 14px;
    }
}
